import type { DashboardReportSummary, PropertyReportSubscriptionAttributes } from 'common'

/** Keep full create/edit responses out of the dashboard's list cache. */
export function toDashboardReportSummary(
  report: PropertyReportSubscriptionAttributes
): DashboardReportSummary {
  const subject = report.subject
  return {
    id: report.id,
    name: report.name,
    user_id: report.user_id,
    created_on: report.created_on,
    modified_on: report.modified_on,
    public_id: report.public_id,
    organization_visibility: report.organization_visibility,
    is_in_portfolio: report.is_in_portfolio,
    tags: report.tags,
    metadata: report.metadata,
    subject: subject
      ? {
          id: subject.id,
          street_address: subject.street_address,
          city: subject.city,
          state: subject.state,
          zip_code: subject.zip_code,
          year_built: subject.year_built,
          number_units: subject.number_units,
          custom_street_view_url:
            'custom_street_view_url' in subject &&
            typeof subject.custom_street_view_url === 'string'
              ? subject.custom_street_view_url
              : null
        }
      : null,
    property_edits: (report.property_edits ?? [])
      .filter((edit) => subject && edit.property_id === subject.id)
      .map(({ property_id, street_address, year_built, number_units, street_view_url }) => ({
        property_id,
        street_address,
        year_built,
        number_units,
        street_view_url
      })),
    access_users: report.access_users ?? [],
    email_schedule: report.email_schedule
      ? {
          emails: report.email_schedule.emails,
          cron_expression: report.email_schedule.cron_expression
        }
      : undefined
  }
}
